/**
 * Related Products Slider Component (Vanilla JS)
 * Handles product teaser slider with lazy loading
 */
;(function () {
	'use strict'

	/**
	 * Initialize products slider when DOM is ready
	 * Wait a bit to ensure Swiper is loaded from tailwind.ts
	 */
	function waitForSwiper() {
		if (typeof window.Swiper !== 'undefined') {
			initProductsSliders()
		} else {
			setTimeout(waitForSwiper, 50)
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', waitForSwiper)
	} else {
		waitForSwiper()
	}

	/**
	 * Initialize all product sliders on the page
	 */
	function initProductsSliders() {
		// Check if Swiper library is available
		if (typeof window.Swiper === 'undefined') {
			console.warn('Swiper library not found. Products slider will not work.')
			return
		}

		const Swiper = window.Swiper

		const sliders = document.querySelectorAll('.slider--products')

		sliders.forEach(sliderElement => {
			// Find navigation elements - they are siblings of slider inside grid-cell-12
			const container = sliderElement.parentElement // grid-cell-12
			const nextButton = container.querySelector('.icon--arrow-slider--next')
			const prevButton = container.querySelector('.icon--arrow-slider--prev')

			// Count slides to determine if navigation is needed
			const slideCount = sliderElement.querySelectorAll('.swiper-slide').length

			// Initialize Swiper
			const productsSwiper = new Swiper(sliderElement, {
				slidesPerView: 'auto',
				centeredSlides: true,
				loop: false,
				// Erst ab 10px Bewegung wischen - sonst wird ein Klick mit leicht
				// verrutschter Maus zur Wischgeste und der Produktlink greift nicht.
				threshold: 10,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 2,
				},
				pagination: {
					el: sliderElement.querySelector('.swiper-pagination'),
					clickable: true,
				},
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
					hideOnClick: false,
				},
				breakpoints: {
					992: {
						centeredSlides: false,
						loop: false,
					},
				},
				// Only enable navigation if there are multiple slides
				allowTouchMove: slideCount > 1,
				// Control navigation visibility
				on: {
					init: function () {
						loadVisibleImages(this)
						updateNavigationVisibility(this)
					},
					slideChange: function () {
						loadVisibleImages(this)
						updateNavigationVisibility(this)
					},
					resize: function () {
						updateNavigationVisibility(this)
					},
				},
			})

			/**
			 * Update navigation button visibility based on current slide and total slides
			 * @param {Swiper} swiper - The Swiper instance
			 */
			function updateNavigationVisibility(swiper) {
				if (!nextButton || !prevButton) return

				// Hide both buttons if only one slide
				if (swiper.slides.length <= 1) {
					nextButton.style.display = 'none'
					prevButton.style.display = 'none'
					return
				}

				// Show/hide prev button
				if (swiper.isBeginning) {
					prevButton.style.display = 'none'
				} else {
					prevButton.style.display = 'block'
				}

				// Show/hide next button
				if (swiper.isEnd) {
					nextButton.style.display = 'none'
				} else {
					nextButton.style.display = 'block'
				}
			}
		})
	}

	/**
	 * Load images in visible and adjacent slides
	 * @param {Swiper} swiper - The Swiper instance
	 */
	function loadVisibleImages(swiper) {
		// On init: load first 8 images
		// On swipe: load current + next 8 images (so always 8 ahead)
		const activeIndex = swiper.activeIndex
		const slidesToLoad = []

		// Load current slide + next 8 slides
		for (let i = 0; i <= 8; i++) {
			slidesToLoad.push(activeIndex + i)
		}

		slidesToLoad.forEach(index => {
			const slide = swiper.slides[index]
			if (!slide) return

			// Find lazy images in this slide
			const lazyImages = slide.querySelectorAll('img[data-src]:not(.lazyloaded)')
			lazyImages.forEach(img => {
				// Load the image
				if (img.dataset.src) {
					img.src = img.dataset.src
					img.classList.remove('lazyload')
					img.classList.add('lazyloaded')

					// Also handle srcset if present
					if (img.dataset.srcset) {
						img.srcset = img.dataset.srcset
					}
				}
			})
		})
	}
})()
